import { useRecordContext } from "react-admin";
import { type DrivingSchool } from "../../providers/drivingSchoolsProvider";
import { useEffect, useState } from "react";
import { getDownloadURL, ref } from "firebase/storage";
import { storage } from "../../firebase";
import { Box, Typography } from "@mui/material";
import { LoadingIndicator } from "../../misc/LoadingIndicator";

export function DrivingSchoolStamp() {
  const drivingSchool = useRecordContext<DrivingSchool>();
  const stampStorageRef = drivingSchool?.stampStorageRef;
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setImageUrl(null);
    if (stampStorageRef) {
      setLoading(true);
      void getDownloadURL(ref(storage, stampStorageRef)).then((url) => {
        setImageUrl(url);
        setLoading(false);
      });
    }
  }, [stampStorageRef]);

  return imageUrl ? (
    <img src={imageUrl} height="120" />
  ) : (
    <Box
      sx={{
        position: "relative", // <-- This is important for the loading indicator to be centered
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "120px",
        border: "1px solid",
        borderColor: "divider",
      }}
    >
      {loading && <LoadingIndicator />}
      {!loading && <Typography color="text.disabled">Kein Fahrschul-Stempel hinterlegt.</Typography>}
    </Box>
  );
}
